import { createContext } from "react";

const AppContext = createContext({
  setCollapsed: () => {},
  setLoading: () => {},
  config: { api: {} },
});
export default AppContext;



// WEBPACK FOOTER //
// ./src/views/Public/context.js